import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-bdc-create-property-complete',
  templateUrl: './bdc-create-property-complete.component.html',
  styleUrls: ['./bdc-create-property-complete.component.scss'],
})
export class BdcCreatePropertyCompleteComponent implements OnInit {
  // TV4-5909: the property can be created on Booking.com while its Tokeet connection
  // fails to configure. When that happens this step must warn instead of celebrating.
  @Input() propertyId?: number
  @Input() connectionError?: { error?: string; error_code?: string } | null
  @Output() prev = new EventEmitter()
  @Output() done = new EventEmitter()
  @Output() connect = new EventEmitter()

  ngOnInit(): void {}
}
